import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { Image } from '@base/lib/ThemeImage'
import { assets } from 'pro/config/assets';
import { get375CssValue } from 'base/utils/dom-size';

export type IconFlagProps = Omit<IconProps, 'size'> & {
    size: number;
    code: string;
}

const emojiMap = {
    US: '🇺🇸',
    CA: '🇨🇦',
    AU: '🇦🇺',
    DE: '🇩🇪',
    GB: '🇬🇧',
}

export const IconFlag: FC<IconFlagProps> = props => {
    const { code, size = 16, className, style } = props;

    if (assets.flagDir) {
        return (
            <Image
                className={className}
                style={style}
                src={`${assets.flagDir}${code.toLowerCase()}.svg`}
                width={size}
                height={size * 0.75}
                background={false}
                fixed
                pure
            />
        )
    }

    const cssSize = get375CssValue(size);

    if (emojiMap[code]) {
        return (
            <div
                className={'flex flex-middle'}
                style={{
                    ...style,
                    width: cssSize,
                    height: cssSize,
                }}
            >
                <div
                    className={'low-line overflow'}
                    style={{
                        height: get375CssValue(size * 0.75),
                        fontSize: cssSize,
                    }}
                >
                    {emojiMap[code] || code}
                </div>
            </div>
        )
    }

    return (
        <div
            className={'low-line overflow text-center text-normal'}
            style={{
                ...style,
                width: cssSize,
                height: cssSize,
                lineHeight: cssSize,
                fontSize: get375CssValue(size * 0.8),
            }}
        >
            {code}
        </div>
    )
};